<ng-template linkTemplate let-dataItem="dataItem">
    <div class="container">
        <wbo-edit-link *ngIf="dataItem.productLine.sellableId" [dataItem]="dataItem" [field]="field"
                       [componentPath]="'productLine'"
                       [editComponent]="ProductLineEditPageComponent" [editMode]="EditMode.VIEW"></wbo-edit-link>
        <wbo-edit-link *ngIf="dataItem.plg.plgId" [dataItem]="dataItem" [field]="field" [componentPath]="'plg'"
                       [editComponent]="PlgEditPageComponent" [editMode]="EditMode.VIEW"></wbo-edit-link>
        <fui-tags *ngIf="dataItem.productLine.sellableId" class="discontinued utility color-dusty-gray">
            <fui-tag *ngIf="dataItem.productLine.discontinued"
                     [title]="dataItem.productLine.discontinued ? discontinuedLabel : unavailableLabel">
                <fui-icon [height]="14" [icon]="'ban'" [width]="14"></fui-icon>
            </fui-tag>
        </fui-tags>
    </div>
</ng-template>
